export default "__VITE_ASSET__CMrhEONG__"